<template>
  <div>
    Blasts
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { preload, preloadMany }  from '@/preloader'

const BlastListQuery = gql`
  query blastList ($teamId: ID!) {
    blastList(teamId: $teamId) {
      list {
        id
        communications {
          ...on Message {
            id
          }
        }
      }
      count
      remaining
    }
  }
`
const preloadQueries = (to) => {
  return [
    {
      query: BlastListQuery,
      queryName: 'blastList',
      variables: {
        teamId: to.params.teamId
      },
      fetchPolicy: 'network-only'
    }
  ]
}

export default {

  props: {
    teamId: {
      required: true
    }
  },

  beforeRouteEnter(to, from, next) {
    preloadMany({
      queries: preloadQueries(to),
      callback: next
    })
  },

  beforeRouteUpdate(to, from, next) {
    preloadMany({
      queries: preloadQueries(to),
      callback: next,
      mountedVm: this
    })
  },

  apollo: {
    blastList: {
      query: BlastListQuery,
      variables() {
        return {
          teamId: this.teamId
        }
      }
    }
  }

}
</script>
